import RepairOrderSearch from "./search/repairOrderSearch";
import RrfWorklog from "./rrfWorklog/rrfWorklog";

export const utilities = (translations) => [
  {
    tab: "Repair Order Search",
    items: [
      {
        title: "Repair Order Search",
        description: "Repair Order Devices Search",
        component: <RepairOrderSearch />,
      },
    ],
  },
  {
    tab: "RRF Worklog",
    items: [
      {
        title: "RRF Worklog",
        description: "RRF Worklog",
        component: <RrfWorklog />,
      },
    ],
  },
];
